import { render, staticRenderFns } from "./layout-menu-button.vue?vue&type=template&id=611cea32&"
import script from "./layout-menu-button.vue?vue&type=script&lang=ts&"
export * from "./layout-menu-button.vue?vue&type=script&lang=ts&"
import style0 from "./layout-menu-button.vue?vue&type=style&index=0&id=611cea32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports